export enum LabelSize {
  DEFAULT = 'default',
  LARGE = 'large',
}
